module.exports = __webpack_public_path__ + "img/uploadblue-icon.1e0d60ad.svg";